import { useI18N } from "@sundae/react-hooks";
import { Text } from "@sundae/ui-toolkit";
import { FC } from "react";
import CardanoExplorer from "../../../../components/CardanoExplorer/CardanoExplorer";
import { CARDANO_EXPLORER_LINK_MAP } from "../../../../constants/cardano.constants";
import { TPendingYieldFarmingTransaction } from "../../../../hooks/farms/useYieldFarmingPositions";
import { useProfileAppContext } from "../../../../stores";

interface IPendingTransactionsProps {
  context: "delegation" | "position";
  transactions: TPendingYieldFarmingTransaction[];
}

const PendingTransactions: FC<IPendingTransactionsProps> = ({ context, transactions }) => {
  const {
    state: { cardanoExplorer },
  } = useProfileAppContext();
  const { t } = useI18N("farms");

  return (
    <div className="grid w-full gap-2">
      <Text className="max-w-[90%]" tag="h2" size="sm">
        {t("portfolio.pendingTransactions.title")}
      </Text>
      <Text className="max-w-[90%]" tag="p" size="xs" variant="muted">
        {t("portfolio.pendingTransactions.copy", { context })}
      </Text>

      <ul className="grid gap-2">
        {transactions.map((transaction) => {
          return (
            <li className="flex items-center gap-1" key={transaction.txHash}>
              <Text tag="span" size="xs" variant="muted">
                {t("transaction", { ns: "glossary" })}:
              </Text>
              <CardanoExplorer
                hash={transaction.txHash}
                type={CARDANO_EXPLORER_LINK_MAP.transaction[cardanoExplorer]}
                size="xs"
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default PendingTransactions;
